import { useAccountConfiguration } from "queries/users"

const useWhatsAppTemplate = (contentSid: string | undefined) => {
  const { accountConfiguration } = useAccountConfiguration()

  const isTemplateBased = Boolean(contentSid)
  const template = contentSid
    ? accountConfiguration.whatsappTemplates?.find(
      (t) => t.contentSid === contentSid,
    ) ?? null
    : null
  const templateUnavailable = isTemplateBased && !template

  return { template, isTemplateBased, templateUnavailable }
}

export default useWhatsAppTemplate
